// 반올림 n: 숫자, d: 소수점 자리수
// 대신에 n.toFixed(d)를 사용해도 됨.
exports.round = (n, d) => {
  if (d <= 0) {
    return Math.round(n);
  }

  var d2 = Math.pow(10, d);
  return Math.round(n * d2) / d2;
};

// 올림 n: 숫자, d: 소수점 자리수
exports.ceil = (n, d) => {
  if (d <= 0) {
    return Math.ceil(n);
  }

  var d2 = Math.pow(10, d);
  return (Math.ceil(n * d2) / d2).toFixed(d);
};

// 내림 n: 숫자, d: 소수점 자리수
exports.floor = (n, d) => {
  if (d <= 0) {
    return Math.floor(n);
  }

  var d2 = Math.pow(10, d);
  return (Math.floor(n * d2) / d2).toFixed(d);
};

// 정수형 반올림 n: 숫자, d: 자리수
exports.roundInt = (n, d) => {
  if (d < 1) {
    d = 1;
  }

  var d2 = Math.pow(10, d);
  return Math.round(n / d2) * d2;
};

// 정수형 올림 n: 숫자, d: 자리수
exports.ceilInt = (n, d) => {
  if (d < 1) {
    d = 1;
  }

  var d2 = Math.pow(10, d);
  return Math.ceil(n / d2) * d2;
};

// 정수형 내림 n: 숫자, d: 자리수
exports.floorInt = (n, d) => {
  if (d < 1) {
    d = 1;
  }

  var d2 = Math.pow(10, d);
  return Math.floor(n / d2) * d2;
};
